import { IsNotEmpty, IsOptional, IsEmail } from "class-validator";

export class GateStewardDto {
  @IsNotEmpty()
  user_id: string;

  @IsOptional()
  first_name?: string;

  @IsOptional()
  last_name?: string;

  @IsOptional()
  @IsEmail()
  email?: string;
}
